import React, { useState, useEffect } from "react";
import axios from "axios";
import {
  Button,
  Image,
  Checkbox,
  Card,
  Grid,
  CardHeader,
  Heading,
  Flex,
  Stack,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  FormControl,
  FormLabel,
  Input,
  Select,
  Box,
  SimpleGrid,
  VStack,
  HStack,
  useToast,
  Text,
  Divider,
  IconButton,
  useDisclosure,
} from "@chakra-ui/react";
import { FaPlus, FaWhatsapp, FaPaperPlane } from "react-icons/fa";
import { BASE_URL } from "../../../Globalapi/Globalapi";

const Allocate_rightside = ({ selectedPickupStop, selectedDropStop, id }) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [fees, setFees] = useState([
    { pickUp: "", drop: "", dropFees: "", discount: "" },
  ]);
  const toast = useToast();

  const [students, setStudents] = useState([]);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [currentPage, setCurrentPage] = useState(1);
  const [filteredStudents, setFilteredStudents] = useState([]);
  const [search, setSearch] = useState("");
  const [classes, setClasses] = useState([]);
  const [divisions, setDivisions] = useState([]);
  const [selectedClass, setSelectedClass] = useState("");
  const [selectedDivision, setSelectedDivision] = useState("");
  const [checkedStudents, setCheckedStudents] = useState({});
  const [busRouteId, setBusRouteId] = useState(""); // You can set this dynamically
  const [busFee, setBusFee] = useState(""); // Set this dynamically too
  const schoolId = sessionStorage.getItem("school_id");

  const addFeeRow = () => {
    setFees([...fees, { pickUp: "", drop: "", dropFees: "", discount: "" }]);
  };

  const itemsPerPage = 25;
  const totalPages = Math.ceil(filteredStudents.length / itemsPerPage);
  const paginatedParents = filteredStudents.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const handleInputChange = (index, field, value) => {
    const updatedFees = [...fees];
    updatedFees[index][field] = value;
    setFees(updatedFees);
  };

  const capitalizeWords = (str) => {
    return str
      .toLowerCase()
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  };

  const getInitials = (name) => {
    return name
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase())
      .join("");
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleSearch = (e) => {
    const query = e.target.value;
    setSearch(query);
    filterStudents(selectedClass, selectedDivision, query);
  };

  const handleClassChange = (e) => {
    setSelectedClass(e.target.value);
    filterStudents(e.target.value, selectedDivision, search);
  };

  const handleDivisionChange = (e) => {
    setSelectedDivision(e.target.value);
    filterStudents(selectedClass, e.target.value, search);
  };

  const handleCheckboxChange = (studentId) => {
    setCheckedStudents((prev) => ({
      ...prev,
      [studentId]: !prev[studentId],
    }));
  };

  const handleWhatsAppClick = (number) => {
    const message = encodeURIComponent(
      "Hello, I'm contacting you regarding your child."
    );
    window.open(`https://wa.me/${number}?text=${message}`, "_blank");
  };

  useEffect(() => {
    const fetchClasses = async () => {
      try {
        const response = await axios.get(
          `${BASE_URL}/admin/class/class_master.php`
        );
        if (response.data.success) {
          setClasses(response.data.data);
        }
      } catch (error) {
        console.error("Error fetching classes:", error);
      }
    };
    fetchClasses();
  }, []);

  const filterStudents = (classValue, divisionValue, query) => {
    const filtered = students.filter((student) => {
      const matchesClass = classValue ? student.class === classValue : true;
      const matchesDivision = divisionValue
        ? student.division === divisionValue
        : true;
      const matchesName = student.name
        .toLowerCase()
        .includes(query.toLowerCase());
      return matchesClass && matchesDivision && matchesName;
    });
    setFilteredStudents(filtered);
  };

  useEffect(() => {
    const fetchDivisions = async () => {
      try {
        const response = await axios.get(
          `${BASE_URL}/admin/class/division.php`
        );
        if (response.data.success) {
          setDivisions(response.data.data);
        }
      } catch (error) {
        console.error("Error fetching divisions:", error);
      }
    };
    fetchDivisions();
  }, []);

  useEffect(() => {
    const fetchStudents = async () => {
      try {
        const response = await axios.post(
          `${BASE_URL}/admin/bus/students/unassigned_students.php`,
          { school_id: schoolId }
        );
        console.log("list", response);
        setStudents(response.data.data);
        setFilteredStudents(response.data.data);
        if (response.data.status === "success") {
          setStudents(response.data.data);
          setFilteredStudents(response.data.data);
        }
      } catch (error) {
        console.error("Error fetching students:", error);
      }
    };
    fetchStudents();
  }, []);

  const handleSubmit = async () => {
    // Collect selected student IDs
    const selectedStudentIds = Object.keys(checkedStudents).filter(
      (id) => checkedStudents[id]
    );

    if (selectedStudentIds.length === 0) {
      toast({
        title: "No Student Selected",
        description: "Please select at least one student.",
        status: "warning",
        duration: 5000,
        isClosable: true,
      });
      return;
    }

    // Construct the data object for API submission
    const data = {
      user_id: sessionStorage.getItem("user_id"), // Logged-in user's ID
      school_id: sessionStorage.getItem("school_id"), // School ID
      bus_route_id: id, // Bus route ID
      pickup_location: selectedPickupStop?.stop_id || null, // Selected pickup stop ID
      drop_location: selectedDropStop?.stop_id || null, // Selected drop stop ID
      bus_fee: selectedPickupStop?.bus_fee || "", // Bus fee for the pickup
      due_date: selectedPickupStop?.due_date || "", // Due date
      student_ids: selectedStudentIds.map((id) => ({
        student_id: parseInt(id, 10),
      })), // Correctly formatted student IDs
      start_date: selectedPickupStop?.start_date || null,
      end_date: selectedPickupStop?.end_date || null,
      trip: selectedPickupStop?.trip || "", // Add trip type here (One-way or Two-way)
    };

    console.log("dataasiign", data);

    try {
      // Make the POST request to assign students
      const response = await axios.post(
        `${BASE_URL}/admin/bus/students/assign_students.php`,
        data
      );
      console.log("response_assign_stddd", response);

      if (response.data.success) {
        toast({
          title: "Students Assigned Successfully",
          description: "Students have been assigned successfully.",
          status: "success",
          duration: 5000,
          isClosable: true,
        });
      } else {
        toast({
          title: "Error Assigning Students",
          description:
            "Error assigning students: " +
            (response.data.message || "Unknown error"),
          status: "error",
          duration: 5000,
          isClosable: true,
        });
      }
    } catch (error) {
      console.error("Error submitting data:", error);
      toast({
        title: "Error Assigning Students",
        description:
          "An error occurred while assigning students. Please try again later.",
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    }
  };

  return (
    <>
      {/* <Flex gap={8} flexDirection={{ base: "column", md: "row" }}>
        <Box
          flex="2"
          p={4}
          border="1px solid"
          borderColor="gray.200"
          borderRadius="md"
          width="100%"
        > */}
      <Flex justify="flex-end" alignItems="center" mb={4}>
        {/* <Text fontSize={{ base: "md", md: "lg" }} fontWeight="bold">
              Students List
            </Text> */}
        <Button mt={2} onClick={handleSubmit} colorScheme="teal">
          Submit
        </Button>
      </Flex>

      <Flex
        direction={{ base: "column", md: "row" }}
        justify="space-between"
        align="center"
        mb={1}
        p={2}
        mt={2}
        className="sb"
        gap={{ base: 4, md: 0 }} // Add gap for spacing
      >
        {/* Rows Per Page */}
        <Flex
          align="center"
          gap={4} // Add gap for spacing between items
          direction={{ base: "column", md: "row" }}
          width={{ base: "100%", md: "auto" }}
        >
          <Select
            width={{ base: "100%", md: "150px" }}
            value={rowsPerPage}
            onChange={(e) => setRowsPerPage(Number(e.target.value))}
            borderColor="#E9EDF4"
          >
            <option value={25}>25</option>
            <option value={50}>50</option>
            <option value={100}>100</option>
          </Select>
        </Flex>

        {/* Filters and Search */}
        <Flex
          direction={{ base: "column", md: "row" }}
          gap={4} // Space between filters and search elements
          justify="flex-end"
          width="100%"
        >
          <Select
            width={{ base: "100%", md: "200px" }} // Adjust width for clarity
            placeholder="Select Class"
            onChange={handleClassChange}
            value={selectedClass}
            fontSize="sm"
          >
            {classes.map((cls) => (
              <option key={cls.id} value={cls.class_name}>
                {cls.class}
              </option>
            ))}
          </Select>

          <Select
            width={{ base: "100%", md: "200px" }} // Adjust width for clarity
            placeholder="Select Division"
            onChange={handleDivisionChange}
            value={selectedDivision}
            fontSize="sm"
          >
            {divisions.map((div) => (
              <option key={div.id} value={div.division_name}>
                {div.division}
              </option>
            ))}
          </Select>

          <Input
            width={{ base: "100%", md: "250px" }} // Adjust width for clarity
            placeholder="Search by name..."
            value={search}
            onChange={handleSearch}
            fontSize="sm"
          />
        </Flex>
      </Flex>

      <Box width="100%" mx="auto">
        <Grid
          templateColumns={{
            base: "repeat(1, 1fr)",
            md: "repeat(2, 1fr)",
            lg: "repeat(3, 1fr)",
          }}
          gap={6}
        >
          {paginatedParents.map((student) => {
            return (
              <Card
                key={student.id}
                boxShadow="md"
                padding={0}
                height="fit-content"
                width="100%"
              >
                <CardHeader padding={1}>
                  <Flex justifyContent="space-between" alignItems="start">
                    <Flex alignItems="center">
                      <Checkbox
                        size="sm"
                        isChecked={!!checkedStudents[student.id]}
                        onChange={() => handleCheckboxChange(student.id)}
                        mr={2}
                        marginBottom={5}
                      />
                      {student.image_url ? (
                        <Image
                          src={
                            student.image_url ||
                            "https://t4.ftcdn.net/jpg/02/29/75/83/360_F_229758328_7x8jwCwjtBMmC6rgFzLFhZoEpLobB6L8.jpg"
                          }
                          alt={student.name}
                          boxSize="2rem"
                          borderRadius="full"
                          onError={(e) => {
                            e.target.src =
                              "https://t4.ftcdn.net/jpg/02/29/75/83/360_F_229758328_7x8jwCwjtBMmC6rgFzLFhZoEpLobB6L8.jpg";
                          }}
                        />
                      ) : (
                        <Box
                          borderRadius="full"
                          bg="teal.500"
                          color="white"
                          boxSize="40px"
                          display="flex"
                          alignItems="center"
                          justifyContent="center"
                          mr={2}
                        >
                          <Text fontSize="lg">
                            {getInitials(capitalizeWords(student.name))}
                          </Text>
                        </Box>
                      )}

                      <Box mr={4}>
                        <Heading size="xs" noOfLines={1}>
                          {capitalizeWords(student.name)}
                        </Heading>
                        <Text fontSize="sm" noOfLines={1}>
                          Class: {student.class}
                        </Text>
                        <Text fontSize="sm" noOfLines={1}>
                          Division: {student.division}
                        </Text>
                      </Box>
                    </Flex>

                    <Button
                      onClick={() => handleWhatsAppClick(student.father_number)}
                      colorScheme="green"
                      size="xs"
                    >
                      <FaWhatsapp />
                    </Button>
                  </Flex>
                </CardHeader>
              </Card>
            );
          })}
        </Grid>
      </Box>

      <Flex justify="end" borderTopWidth="1px" mt={1} className="sb2" p={3}>
        <Button
          onClick={() => handlePageChange(currentPage - 1)}
          isDisabled={currentPage === 1}
        >
          Prev
        </Button>
        <Stack direction="row" mx={2}>
          {currentPage > 1 && (
            <>
              <Button onClick={() => handlePageChange(1)}>1</Button>
              {currentPage > 2 && <Text>...</Text>}
            </>
          )}
          <Button backgroundColor="teal" color="white">
            {currentPage}
          </Button>
          {currentPage < totalPages - 1 && (
            <>
              <Text>...</Text>
              <Button onClick={() => handlePageChange(totalPages)}>
                {totalPages}
              </Button>
            </>
          )}
        </Stack>
        <Button
          onClick={() => handlePageChange(currentPage + 1)}
          isDisabled={currentPage === totalPages}
        >
          Next
        </Button>
      </Flex>
      {/* </Box>
      </Flex> */}
    </>
  );
};

export default Allocate_rightside;
